<template>
    <div v-if="showInfoModal">
        <b-modal v-model="showInfoModal"
                 :content-class=" 'custom-modal ' + (settings.sectionClass ? settings.sectionClass : '')" ref="vuemodal" @hide="showDropdownOnClose">
            <template v-slot:modal-header="{ close }">
                <span class="close-icon" @click="onClose"></span>
            </template>
            <div v-if="settings.edit_mode">{{ translate('sldEditIcon') }}</div>
            <div v-else>{{ translate('sldUploadIcon') }}</div>
            <br>
            <div class="inputs__wrapper">
                <md-field :class="{'md-invalid': showErrorMassage}">
                    <label>{{ translate('sldIconTag') }}</label>
                    <md-input v-if="settings.edit_mode" required v-model="settings.icon_tag"/>
                    <md-input v-else required v-model="icon_tag"/>
                    <span class="md-error">{{ translate('sldPleaseFillInput') }}</span>
                </md-field>
                <md-field :class="{'md-invalid': showErrorMassage}">
                    <label>{{ translate('sldDefaultText') }}</label>
                    <md-input v-if="settings.edit_mode" required v-model="settings.icon_default_text"/>
                    <md-input v-else required v-model="icon_default_text"/>
                    <span class="md-error">{{ translate('sldPleaseFillInput') }}</span>
                </md-field>
            </div>
            <b-form-checkbox v-model="isSvg">Is SVG</b-form-checkbox>
            <div class="input__wrapper">
                <div class="input__content">
                    <input
                        type="file"
                        @change="onFileSelected"
                        ref="fileInput"
                    >
                    <div class="optional" v-if="settings.edit_mode">(Optional)</div>
                </div>
                <div class="error__massage" v-if="!settings.edit_mode" :class="{show: showErrorMassage}">
                    {{ translate('sldChooseIcon') }}
                </div>
            </div>
            <div class="preview" v-if="files.length > 0">
                <img v-for="(item, index) in files"
                     :key="index"
                     :src="item.url"/>
            </div>


            <template v-slot:modal-footer>
                <div class="footerButton__wrapper">
                    <a class="onOk__btn" @click="saveIconClick">
                        <div>
                            <span>{{ translate('Save') }}</span>
                        </div>
                    </a>
                    <a class="onOk__btn" v-if="settings.show_add_more_btn" @click="saveAndAddMoreClick">
                        <div>
                            <span>{{ translate('sldSaveAndAddMore') }}</span>
                        </div>
                    </a>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
import _ from "lodash";
import errorMixin from '@/mixins/errorMixin';
import {mapActions, mapMutations} from "vuex";

export default {
    name: 'customModalPopap',

    mixins: [errorMixin],

    data() {
        return {
            showInfoModal: !_.isEmpty(this.settings),
            files: [],
            icon_tag: '',
            icon_default_text: '',
            showErrorMassage: false,
            saveAndAddMore: false,
            isSvg: false,
        }
    },

    watch: {
        settings(newValue) {
            this.showInfoModal = !_.isEmpty(newValue)
        }
    },

    props: {
        settings: {
            type: [Object, null],
            default: () => {
                return {
                    windowWidth: null,
                }
            }
        },
    },

    methods: {

        ...mapActions({
            uploadLandingFile: 'question/uploadLandingFile',
            saveNewIcon: 'question/saveNewIcon',
            editIconSld: 'question/editIconSld'
        }),
        ...mapMutations({
            setProgressBarTag: 'setProgressBarTag',
        }),


        async onClose() {
            this.showInfoModal = false
            if (this.settings.onCancelHandler) {
                try {
                    await this.settings.onCancelHandler(this.settings)
                } catch (error) {
                    this.showErrorModal(error.message)
                }
            }
            this.clearPopupFields()
            this.showErrorMassage = false
        },
        showDropdownOnClose() {
            this.settings.onCancelHandler()
        },

        async onFileSelected(event) {
            for (let i = 0; event.target.files.length > i; i++) {
                let selectedFile = event.target.files[i];
                this.files.push({
                    file: selectedFile,
                    url: URL.createObjectURL(selectedFile)
                })
            }
        },
        saveIconClick() {
            this.checkEmptyFields()
            if (!this.showErrorMassage) {
                this.saveIconAction()
                this.clearPopupFields()
                this.showInfoModal = false
            }

        },
        saveAndAddMoreClick() {
            this.checkEmptyFields()
            if (!this.showErrorMassage) {
                this.showInfoModal = true
                this.saveAndAddMore = true
                this.saveIconAction(this.saveAndAddMore)
                this.clearPopupFields()
            }
        },

        async saveIconAction(saveAndAddMore) {
            let body
            if (this.settings.edit_mode) {
                body = {
                    tag: this.settings.icon_tag,
                    default_text: this.settings.icon_default_text,
                    file: this.files.map(item => item.file),
                    image_guid: this.settings.image_guid
                }
            } else {
                body = {
                    tag: this.icon_tag,
                    default_text: this.icon_default_text,
                    file: this.files.map(item => item.file)
                }
            }
            try {
                body.is_svg = this.isSvg
                this.setProgressBarTag({
                    show: true,
                    tag: 'save icon'
                })
                if (this.settings.edit_mode) {
                    const response = await this.editIconSld(body)
                    this.settings.onEditIconHandler(this.settings.old_image ,response.image)
                } else {
                    const response = await this.saveNewIcon(body);
                    if(saveAndAddMore) {
                        this.settings.onIconAddedAndMore(response.image)
                    } else {
                        this.settings.onIconAddedHandler(response.image)
                    }
                }
            } catch (e) {
                console.log('error', e)
                if(!this.settings.errorHandler || !this.settings.errorHandler(e)) {
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                }
            } finally {
                this.setProgressBarTag({
                    show: false,
                    tag: 'save icon'
                })
                this.uploadSpinner = false
            }
        },
        clearPopupFields() {
            this.icon_tag = ''
            this.icon_default_text = ''
            this.files = []
            this.showErrorMassage = false
            this.$refs.fileInput.value = ''
            console.log(this.files)
        },
        checkEmptyFields() {
            this.showErrorMassage = this.settings.edit_mode ? this.settings.icon_tag == '' || this.settings.icon_default_text == '' : this.icon_tag == '' || this.icon_default_text == '' || this.files.length == 0
        }



    },
}
</script>

<style scoped>
.error__massage {
    color: red;
    display: none;
    font-size: 12px;
    font-style: normal;
    font-width: normal;
}

.error__massage.show {
    display: block;
    text-align: start;
    padding-top: 6px;
}

.input__wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

input {
    display: flex;
}
.optional {
    font-size: 14px;
}
.input__content {
    display: flex;
    align-items: center;
}
.preview img {
    width: 90px;
    margin-top: 15px;
}

.inputs__wrapper {
    display: flex;
    justify-content: space-between;
}

.md-field {
    margin-right: 25px !important;
}

.upload_result {
    border: 1px solid black;
    margin-top: 16px;
    padding: 8px;
}

.response_input_block button {
    height: 35px;
    margin-left: 12px;
}

.response_input_block {
    display: flex;
    align-items: center;
}

.response_input_md {
    margin-top: 0px;
}

.onOk__btn:first-child {
    margin-right: 25px;
}
</style>